import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import shell i18n instance to get its resources
import { i18n as shellI18n } from '@airclou/shell'

// Import dashboard-specific translations
import dashboardEn from './locales/en.json'
import dashboardZh from './locales/zh.json'

// Get existing resources from shell
const shellResources = shellI18n.options.resources || {}

// Extend shell resources with dashboard-specific translations
const resources = {
  en: {
    translation: shellResources.en?.translation || {},
    dashboard: dashboardEn
  },
  zh: {
    translation: shellResources.zh?.translation || {},
    dashboard: dashboardZh
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'dashboard',
    ns: ['translation', 'dashboard'],
    debug: false,

    interpolation: {
      // Left off on purpose: React escapes everything it renders, so escaping
      // here as well would double-escape apostrophes and ampersands in the
      // translated copy. The catch is that it makes t() output unsafe to hand
      // to dangerouslySetInnerHTML — for copy that needs <strong>/<br> around
      // a user-supplied value, use <Trans> instead (see transInterpolation.test.tsx).
      escapeValue: false
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'dashboard:i18nextLng',
      caches: ['localStorage']
    }
  })

export default i18n
